@use "@fukuri-admins/ui/layout" as *;

.deleteMenuItem {
  color: text('Red');
}
